import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchMe } from './store/auth/authSlice';

import Summary from './views/Summary';
import Page from './components/Page';

interface Props {
  url: string;
}

const PrivateRouter = ({ url }: Props): React.ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMe());
  }, [dispatch]);

  return (
    <Page>
      <Route path={`${url}/`} component={Summary} exact />
    </Page>
  );
};

export default PrivateRouter;
